import { React, useState, useEffect } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../../../Context/LanguageContext';

export default function PointHistoryColumn() {
  const { t } = useLanguage();

  return (
    <TopLevelWrapper>
      <Column width={326} style={{marginLeft: '28px'}}>
        <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{t('memberDetail.colAppliedContent')}</Text>
      </Column>
      <Column width={450}>
        <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{t('memberDetail.colAppliedDate')}</Text>
      </Column>
      <Column width={76}>
        <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{t('memberDetail.colPoints')}</Text>
      </Column>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin: 34px 0px 20px 0px;

  width: 1020px;

  gap: 12px;

  transition: all 0.3s ease-in-out;
`;

const Column = styled.div`
  display: flex;
  flex-direction: row;
  
  justify-content: flex-start;
  align-items: flex-start;

  width: ${props => props.width}px;
  height: 20px;

  overflow: hidden;
`;

const Text = styled.p`
  font-family: ${props => props.fontFmaily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;